import { render } from "./Signpad.vue?vue&type=template&id=85e3ad28&scoped=true"
import script from "./Signpad.vue?vue&type=script&lang=js"
export * from "./Signpad.vue?vue&type=script&lang=js"

import "./Signpad.vue?vue&type=style&index=0&id=85e3ad28&scoped=true&lang=scss"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e3ad28"],['__file',"src/views/Signpad.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85e3ad28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85e3ad28', __exports__)) {
    console.log('reload')
    api.reload('85e3ad28', __exports__)
  }
  
  module.hot.accept("./Signpad.vue?vue&type=template&id=85e3ad28&scoped=true", () => {
    console.log('re-render')
    api.rerender('85e3ad28', render)
  })

}


export default __exports__